import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchBusinessUnits = createAsyncThunk(
  'businessUnits/fetchBusinessUnits',
  async (
    { pageIndex, pageSize, searchQuery, sortOrder, sortedColumnId } = {},
    { rejectWithValue, extra: { gccApiClient } },
  ) => {
    const response = await gccApiClient.getBusinessUnits(pageIndex, pageSize, searchQuery, sortOrder, sortedColumnId);
    if (response.error_code) {
      return rejectWithValue({ errorCode: response.error_code });
    }
    const { data, pagination } = response;
    return { data, pagination };
  },
);

export const fetchBusinessUnitDetails = createAsyncThunk(
  'businessUnits/fetchBusinessUnitDetails',
  async ({ businessUnitId } = {}, { rejectWithValue, extra: { gccApiClient } }) => {
    const response = await gccApiClient.getBusinessUnitDetails(businessUnitId);
    if (response.error_code) {
      return rejectWithValue({ errorCode: response.error_code });
    }
    return { businessUnit: response };
  },
);
